const configs = {
    'localhost': {
        environment: 'local',
        api: 'https://api-alfa-utilities-fc-devl.jdf-alfa2-devl-vpn2.eu.e10.c01.johndeerecloud.com',
        core: 'https://fc-devl-r2-core-financeconnect.deere.com',
        pos: 'https://fc-devl-r2-pos-financeconnect.deere.com',
        auth: {
            url: 'https://sso-dev.johndeere.com',
            clientId: '0oanv6n8xoGVjF4Pt0h7'
        }
    },
    'fc-devl-casemanagement-financeconnect.deere.com': {
        environment: 'devl',
        api: 'https://api-alfa-utilities-fc-devl.jdf-alfa2-devl-vpn2.eu.e10.c01.johndeerecloud.com',
        core: 'https://fc-devl-r2-core-financeconnect.deere.com',
        pos: 'https://fc-devl-r2-pos-financeconnect.deere.com',
        auth: {
            url: 'https://sso-dev.johndeere.com',
            clientId: '0oanv6n8xoGVjF4Pt0h7'
        }
    },
    'fc-qual-casemanagement-financeconnect.deere.com': {
        environment: 'qual',
        api: 'https://api-alfa-utilities-fc-qual.alfa2-qual-floating.eu.e10.c01.johndeerecloud.com',
        core: 'https://fc-qual-r2-core-financeconnect.deere.com',
        pos: 'https://pos-gateway-fc-qual.alfa2-qual-floating.eu.e10.c01.johndeerecloud.com',
        auth: {
            url: 'https://sso-qual.johndeere.com',
            clientId: '0oao6s3bwt9Sx96Df0h7'
        }
    },
    'casemanagement-financeconnect.deere.com': {
        environment: 'prod',
        core: 'https://r2-core-financeconnect.deere.com',
        pos: 'https://financeconnect.deere.com',
        auth: {
            url: 'https://sso.johndeere.com',
            clientId: '0oacc5powaRBBgTEC1t7'
        }
    }
};

const config = configs[location.hostname];

config.FONT_DOMAIN='https://fonts.googleapis.com';
if (!config.api) {
    config.api = `https://api-${location.hostname}`;
}

config.isDevelopmentEnvironment = ['local', 'devl'].includes(config.environment);
config.isProductionEnvironment = ['prod'].includes(config.environment);
config.isQualityEnvironment = ['qual'].includes(config.environment);

export {config};
